// assets
import HandshakeIcon from '@mui/icons-material/Handshake';
import GavelIcon from '@mui/icons-material/Gavel';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Alianza Estratégica',
  type: 'group',
  children: [
    // Lineamientos LGMDE
    {
      id: 'alliance',
      title: 'Alianza',
      type: 'item',
      url: '/alliance',
      icon: HandshakeIcon,
      breadcrumbs: false
    },
    {
      id: 'structureProcedure',
      title: 'Estructura & Procedimiento',
      type: 'item',
      url: '/structureProcedure',
      icon: AccountTreeIcon,
      breadcrumbs: false
    },
    {
      id: 'law',
      title: 'Ley General',
      type: 'item',
      url: '/law',
      icon: GavelIcon,
      breadcrumbs: false
    },
    {
      id: 'guidelines',
      title: 'Lineamientos LGMDE',
      type: 'item',
      url: '/guidelines',
      icon: SummarizeIcon,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
